import React from "react";
import styles from "./AppDownloadModal.module.css";
import { t } from "../../utils/i18n";
import { TextWithGameeBrand } from "../../utils/brand";
import gameeQrLogo from "../../Resources/image/gamee-qr-logo.png";

const AppDownloadModal = ({
  open,
  loading = false,
  previewUrl = "",
  versionName = "",
  description = "",
  downloading = false,
  onClose,
  onDownload,
}) => {
  if (!open) return null;

  const qrSrc = previewUrl
    ? `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(previewUrl)}`
    : "";

  const displayDescription =
    description ||
    t(
      "app.download.modal.description",
      "Scan the QR code or tap the button below to download the Gamee App and discover more games on mobile.",
    );

  return (
    <div
      className={styles.overlay}
      role="dialog"
      aria-modal="true"
      aria-label={t("app.download.modal.title", "Download Gamee App")}
      onClick={onClose}
    >
      <div
        className={styles.content}
        onClick={e => e.stopPropagation()}
      >
        <button
          type="button"
          className={styles.closeBtn}
          onClick={onClose}
          aria-label={t("common.close", "Close")}
        >
          ✕
        </button>

        <div className={styles.appInfo}>
          <img
            src={gameeQrLogo}
            alt={t("app.download.modal.title", "Download Gamee App")}
            className={styles.appLogo}
          />
          <div className={styles.appMeta}>
            <h3 className={styles.appTitle}>
              {t("app.download.modal.title", "Download Gamee App")}
            </h3>
            {versionName ? (
              <p className={styles.appVersion}>
                {t("app.download.modal.version", "Version {version}", {
                  version: versionName,
                })}
              </p>
            ) : null}
          </div>
        </div>

        <p className={styles.description}>{displayDescription}</p>

        <div className={styles.downloadArea}>
          <div className={styles.qrBox}>
            {loading || !qrSrc ? (
              <div className={styles.qrPlaceholder} aria-hidden="true" />
            ) : (
              <img
                src={qrSrc}
                alt={t("game.modal.scan", "Scan to download with")}
                className={styles.qrImage}
              />
            )}
            <p className={styles.qrCaption}>
              {t("app.download.modal.scanHint", "Scan to download on your phone")}
            </p>
          </div>

          <div className={styles.actionBox}>
            <h4 className={styles.actionTitle}>
              {t("home.downloadApp", "Download App")}
            </h4>
            <button
              type="button"
              className={styles.downloadBtn}
              disabled={loading || downloading || !previewUrl}
              aria-busy={downloading}
              onClick={onDownload}
            >
              {downloading
                ? t("home.downloadApp.loading")
                : t("home.downloadApp", "Download App")}
            </button>
          </div>
        </div>

        <div className={styles.verifiedBadge}>
          <span>
            <TextWithGameeBrand
              text={t("game.modal.verified", "Verified by Gamee")}
            />
          </span>
          <span aria-hidden="true">✅</span>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadModal;
